import React, { useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "../CreateRetailAgent/CreateRetailAgent.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../constant";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import { isValidPostalCode } from "../../utils/postalCodeValidator";
const regionOptions = {
  "United Kingdom": ["England - City of London","England - Greater London","England - Greater Manchester","England - West Midlands","Scotland - City of Edinburgh","Scotland - City of Glasgow","Wales - Cardiff","Northern Ireland - Antrim"],
  "United States": ["North America"],
  India: ["Delhi","Karnataka","Maharashtra","Tamil Nadu"],
  Nigeria: ["Africa"],
  Ghana: ["Africa"],
  Kenya: ["Africa"],
  "South Africa": ["Africa"],
  Canada: ["Alberta","British Columbia","Ontario","Quebec"],
  Australia: ["Oceania"],
  Germany: ["Europe"],
  France: ["Europe"],
  Ireland: ["Europe"],
};

const CreateMember = () => {
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "", last_name: "", email: "", phone_number: "",
    country: "United Kingdom", region: "England - City of London",
    address_line1: "", address_line2: "", address_line3: "",
    city: "", postcode: "", password: "", password_confirmation: "",
    showPassword: false, showConfirmPassword: false,
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [touched, setTouched] = useState({});

  const styles = {
    container: { minHeight: "100vh", fontFamily: "Arial, sans-serif", display: "flex", flexDirection: "column", justifyContent: "space-between", marginTop: "30px" },
    formWrapper: { display: "flex", justifyContent: "center", padding: "0px", flex: 1, boxSizing: "border-box", marginTop: "120px", width: "100%", marginBottom: "120px" },
    formCard: { backgroundColor: "#ffffff", padding: "32px", borderRadius: "17.6px", width: "100%", maxWidth: "1500px", boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)", boxSizing: "border-box" },
    heading: { textAlign: "center", fontSize: "28px", fontWeight: "900", marginBottom: "4px", background: "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 60%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
    subheading: { textAlign: "center", color: "#063b8a", fontWeight: "700", fontSize: "14px", marginBottom: "24px" },
    sectionTitle: { fontSize: "18px", fontWeight: "700", color: "#052C65", marginBottom: "12px" },
    label: { fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" },
    inputRow: { display: "flex", gap: "24px", flexWrap: "wrap" },
    inputRowChild: { flex: "1", minWidth: "200px" },
    input: { width: "100%", height: "40px", padding: "9px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "14px", boxSizing: "border-box" },
    errorInput: { width: "100%", height: "40px", padding: "9px", borderRadius: "12px", border: "1px solid #d32f2f", fontSize: "14px", boxSizing: "border-box" },
    select: { width: "100%", height: "40px", padding: "9px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "14px", boxSizing: "border-box" },
    button: { width: "40%", padding: "12px", backgroundColor: "#000080", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "500", cursor: "pointer", fontSize: "16px" },
    error: { color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" },
    checkbox: { display: "flex", gap: "10px", fontSize: "13px", color: "#000080", marginBottom: "16px" },
    link: { color: "#4f46e5", textDecoration: "underline" },
    loginLink: { textAlign: "center", marginTop: "16px", fontSize: "16px", color: "#052C65" },
    box: { backgroundColor: "#ffffff", border: "1px solid #dcdcdc", borderRadius: "17.6px", padding: "20px", marginBottom: "16px", boxSizing: "border-box" },
  };

  const validate = {
    first_name: (v) => !v.trim() ? "First name is required" : v.length < 3 ? "Min 3 characters" : "",
    last_name: (v) => !v.trim() ? "Last name is required" : v.length < 2 ? "Min 2 characters" : "",
    email: (v) => !v.trim() ? "Email is required" : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "Invalid email" : "",
    phone_number: (v) => !v ? "Phone is required" : v.replace(/\D/g, "").length < 10 ? "Invalid phone" : "",
    password: (v) => !v ? "Password is required" : v.length < 8 ? "Min 8 characters" : !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/.test(v) ? "Include uppercase, lowercase, number & special char" : "",
    password_confirmation: (v) => !v ? "Confirm password" : v !== formData.password ? "Passwords don't match" : "",
    address_line1: (v) => !v.trim() ? "Address is required" : "",
    city: (v) => !v.trim() ? "City is required" : "",
    postcode: (v) => !v.trim() ? "Postcode is required" : (!isValidPostalCode(v) ? "Please enter a valid postcode" : ""),
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (touched[name] && validate[name]) setErrors(prev => ({ ...prev, [name]: validate[name](value) }));
    if (message.text) setMessage({ text: "", type: "" });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    if (validate[name]) setErrors(prev => ({ ...prev, [name]: validate[name](value) }));
  };

  const handlePhoneChange = (value) => {
    setFormData(prev => ({ ...prev, phone_number: value }));
    if (touched.phone_number) setErrors(prev => ({ ...prev, phone_number: validate.phone_number(value) }));
  };

  const handleRegionChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setFormData(prev => ({ ...prev, country: value, region: regionOptions[value]?.[0] || "" }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(validate).forEach(key => { newErrors[key] = validate[key](formData[key] || ""); });
    setErrors(newErrors);
    setTouched(Object.keys(validate).reduce((a, k) => ({ ...a, [k]: true }), {}));
    if (!agreedToTerms) { setMessage({ text: "Please accept Privacy Policy and Terms", type: "error" }); return false; }
    return !Object.values(newErrors).some(e => e !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) { setMessage({ text: "Please verify you are not a robot.", type: "error" }); return; }
    if (!validateForm()) return;
    setIsLoading(true);
    setMessage({ text: "", type: "" });

    try {
      localStorage.setItem("tempPassword", formData.password);
      const body = {
        first_name: formData.first_name, last_name: formData.last_name,
        email: formData.email, phone_number: formData.phone_number,
        country_name: formData.country, region: formData.region,
        address_line1: formData.address_line1, address_line2: formData.address_line2,
        address_line3: formData.address_line3, city: formData.city,
        postcode: formData.postcode, password: formData.password,
        password_confirmation: formData.password_confirmation,
      };

      const response = await fetch(`${API_URL}/api/member/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage({ text: "Account created! Check your email for verification.", type: "success" });
        localStorage.setItem("verifyEmail", formData.email);
        setTimeout(() => navigate("/verify-email-m"), 2000);
      } else {
        if (data.errors) {
          const firstKey = Object.keys(data.errors)[0];
          setMessage({ text: data.errors[firstKey][0], type: "error" });
        } else {
          setMessage({ text: data.message || "Registration failed.", type: "error" });
        }
      }
    } catch (error) {
      setMessage({ text: "Network error. Please try again.", type: "error" });
    } finally { setIsLoading(false); }
  };

  const renderField = (name, label, type = "text", placeholder = "") => (
    <div style={styles.inputRowChild}>
      <label style={styles.label}>{label}</label>
      <div style={{ position: "relative" }}>
        <input
          type={type === "password" ? (formData[name === "password" ? "showPassword" : "showConfirmPassword"] ? "text" : "password") : type}
          name={name} placeholder={placeholder} value={formData[name]}
          onChange={handleInputChange} onBlur={handleBlur}
          style={touched[name] && errors[name] ? styles.errorInput : styles.input}
        />
        {type === "password" && (
          <span style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#666" }}
            onClick={() => setFormData(prev => ({ ...prev, [name === "password" ? "showPassword" : "showConfirmPassword"]: !prev[name === "password" ? "showPassword" : "showConfirmPassword"] }))}>
            {formData[name === "password" ? "showPassword" : "showConfirmPassword"] ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      {touched[name] && errors[name] && <span style={styles.error}>{errors[name]}</span>}
    </div>
  );

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.formWrapper}>
        <div className="form-card1 p-3 m-3 pt-4" style={styles.formCard}>
          <h2 style={styles.heading}>Create Member Account</h2>
          <p style={styles.subheading}>Join TopCoin UK as a Member</p>

          {message.text && (
            <div style={{ textAlign: "center", padding: "10px", borderRadius: "8px", margin: "20px 0", fontWeight: "500",
              backgroundColor: message.type === "error" ? "#ffebee" : "#e8f5e9",
              color: message.type === "error" ? "#c62828" : "#2e7d32" }}>
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Personal Info */}
            <div style={styles.box}>
              <h4 style={styles.sectionTitle}>Personal Information</h4>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                {renderField("first_name", "First Name *", "text", "John")}
                {renderField("last_name", "Last Name *", "text", "Wick")}
              </div>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                <div style={styles.inputRowChild}>
                  <label style={styles.label}>Email *</label>
                  <input type="email" name="email" placeholder="john@example.com" value={formData.email}
                    onChange={handleInputChange} onBlur={handleBlur}
                    style={touched.email && errors.email ? styles.errorInput : styles.input} />
                  {touched.email && errors.email && <span style={styles.error}>{errors.email}</span>}
                </div>
                <div style={styles.inputRowChild}>
                  <label style={styles.label}>Phone Number *</label>
                  <PhoneInput country={"gb"} value={formData.phone_number} onChange={handlePhoneChange}
                    onBlur={() => { setTouched(p => ({ ...p, phone_number: true })); setErrors(p => ({ ...p, phone_number: validate.phone_number(formData.phone_number) })); }}
                    inputStyle={{ width: "100%", height: "40px", padding: "9px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "14px", paddingLeft: "52px" }} />
                  {touched.phone_number && errors.phone_number && <span style={styles.error}>{errors.phone_number}</span>}
                </div>
              </div>
            </div>

            {/* Address */}
            <div style={styles.box}>
              <h4 style={styles.sectionTitle}>Address</h4>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                <div style={styles.inputRowChild}>
                  <label style={styles.label}>Country *</label>
                  <select name="country" value={formData.country} onChange={handleRegionChange} style={styles.select}>
                    {Object.keys(regionOptions).map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div style={styles.inputRowChild}>
                  <label style={styles.label}>Region *</label>
                  <select name="region" value={formData.region} onChange={handleRegionChange} style={styles.select}>
                    {(regionOptions[formData.country] || []).map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                </div>
              </div>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                {renderField("address_line1", "Address Line 1 *", "text", "123 Main Street")}
                {renderField("address_line2", "Address Line 2", "text", "Apt 4B")}
              </div>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                {renderField("city", "City *", "text", "London")}
                {renderField("postcode", "Postcode *", "text", "SW1A 1AA")}
              </div>
            </div>

            {/* Password */}
            <div style={styles.box}>
              <h4 style={styles.sectionTitle}>Security</h4>
              <div style={styles.inputRow} className="inputfieldcontainer gap-1 gap-md-3 mb-3">
                {renderField("password", "Password *", "password", "Enter password")}
                {renderField("password_confirmation", "Confirm Password *", "password", "Re-enter password")}
              </div>
            </div>

            {/* Terms */}
            <div style={{ ...styles.checkbox, marginBottom: "20px" , justifyContent: "center"}}>
              <input type="checkbox" checked={agreedToTerms} onChange={(e) => setAgreedToTerms(e.target.checked)} />
              <label>I agree to the <a href="/privacy-policy" style={styles.link}>Privacy Policy</a> and <a href="/terms-and-conditions" style={styles.link}>Terms & Conditions</a></label>
            </div>

            {/* reCAPTCHA */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
              <ReCAPTCHA sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" onChange={(token) => setCaptchaToken(token)} />
            </div>

            {/* Submit */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "32px" }}>
              <button type="submit" style={{ ...styles.button, opacity: isLoading ? 0.7 : 1, cursor: isLoading ? "not-allowed" : "pointer" }} disabled={isLoading}>
                {isLoading ? "Creating Account..." : "Create Account"}
              </button>
            </div>

            <div style={styles.loginLink}>
              Already have a member account?{" "}
              <a href="/member-login" style={{ color: "#052C65", fontWeight: "700", textDecoration: "none" }}>Sign in</a>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CreateMember;
